/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BreedingPlan } from '../models/BreedingPlan';
import type { PaginatedBreedingPlanList } from '../models/PaginatedBreedingPlanList';
import type { PatchedBreedingPlan } from '../models/PatchedBreedingPlan';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BreedingplanService {
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns PaginatedBreedingPlanList
   * @throws ApiError
   */
  public static breedingplanList({
    mareOrganisationUid,
    mareUid,
    mareUidIn,
    o,
    page,
    pageSize,
    usageType,
    usageTypeIn,
    year,
    yearGt,
    yearGte,
    yearLt,
    yearLte,
  }: {
    mareOrganisationUid: string,
    mareUid?: string,
    /**
     * Multiple values may be separated by commas.
     */
    mareUidIn?: Array<string>,
    /**
     * Which field to use when ordering the results.
     */
    o?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    /**
     * * `KI` - KI (self-pregnancy)
     * * `ET` - ET
     * * `ICSI` - ICSI
     */
    usageType?: 'ET' | 'ICSI' | 'KI',
    /**
     * Multiple values may be separated by commas.
     */
    usageTypeIn?: Array<string>,
    year?: number,
    yearGt?: number,
    yearGte?: number,
    yearLt?: number,
    yearLte?: number,
  }): CancelablePromise<PaginatedBreedingPlanList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
      },
      query: {
        'mare__uid': mareUid,
        'mare__uid__in': mareUidIn,
        'o': o,
        'page': page,
        'page_size': pageSize,
        'usage_type': usageType,
        'usage_type__in': usageTypeIn,
        'year': year,
        'year__gt': yearGt,
        'year__gte': yearGte,
        'year__lt': yearLt,
        'year__lte': yearLte,
      },
    });
  }
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns BreedingPlan
   * @throws ApiError
   */
  public static breedingplanCreate({
    mareOrganisationUid,
    requestBody,
  }: {
    mareOrganisationUid: string,
    requestBody: BreedingPlan,
  }): CancelablePromise<BreedingPlan> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns BreedingPlan
   * @throws ApiError
   */
  public static breedingplanRetrieve({
    mareOrganisationUid,
    uid,
  }: {
    mareOrganisationUid: string,
    uid: string,
  }): CancelablePromise<BreedingPlan> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
        'uid': uid,
      },
    });
  }
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns BreedingPlan
   * @throws ApiError
   */
  public static breedingplanUpdate({
    mareOrganisationUid,
    uid,
    requestBody,
  }: {
    mareOrganisationUid: string,
    uid: string,
    requestBody: BreedingPlan,
  }): CancelablePromise<BreedingPlan> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns BreedingPlan
   * @throws ApiError
   */
  public static breedingplanPartialUpdate({
    mareOrganisationUid,
    uid,
    requestBody,
  }: {
    mareOrganisationUid: string,
    uid: string,
    requestBody?: PatchedBreedingPlan,
  }): CancelablePromise<BreedingPlan> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * This is a bit ugly, but the NestedViewSetMixin requires a parent queryset.
   * And GetQuerySetForUser can not have a parent.
   * And we need to annotate the queryset.
   * So the order of this mixin is super important and it works. *PRAGMATISM*
   * @returns void
   * @throws ApiError
   */
  public static breedingplanDestroy({
    mareOrganisationUid,
    uid,
  }: {
    mareOrganisationUid: string,
    uid: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v5/organisations/{mare__organisation__uid}/breedingplan/{uid}',
      path: {
        'mare__organisation__uid': mareOrganisationUid,
        'uid': uid,
      },
    });
  }
}
